module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_Dark-b8318418456fa7796cca3799c094dd0c.png";